"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.WarningSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var WarningSVG = function WarningSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("path", {
    stroke: "none",
    d: "M29.75 26l-12-22a2 2 0 00-3.52 0l-12 22A2 2 0 004 29h24a2 2 0 001.75-3zM17.5 24a1.5 1.5 0 01-3 0 1.49 1.49 0 011.5-1.5 1.48 1.48 0 011.5 1.5zm-.44-4.83a1.09 1.09 0 01-2.11 0l-.69-6.4a1.74 1.74 0 113.48 0z"
  }));
};
exports.WarningSVG = WarningSVG;
WarningSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(WarningSVG);
exports.default = _default;